module.exports = __webpack_public_path__ + "static/media/baroudiLogo.b4c741d4.png";